/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Action_Requires_OnlineInputs */



/**
* | output |
* | --- |
* | "This action requires an internet connection." |
*
* @param {Error_Action_Requires_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const error_action_requires_online = /** @type {((inputs?: Error_Action_Requires_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Action_Requires_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette action nécessite une connexion Internet.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta acción requiere conexión a Internet.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Esta ação requer uma conexão com a internet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa azione richiede una connessione a internet.")
	return /** @type {LocalizedString} */ ("This action requires an internet connection.")
});